var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Bluebird from "bluebird";
import Observer from "../asset/observer";
import { ServerError } from "./socket.service";
import h from "../helper/helper";
import Progress from "../asset/Progress";
var MAXIMUMPARTSIZE = 1000 * 1000;
var STARTPARTSIZE = 5 * 1000;
var MINIMUMPARTSIZE = 1 * 1000;
var MAXIMUMTIME = 2 * 1000;
var BlobDownloader = /** @class */ (function (_super) {
    __extends(BlobDownloader, _super);
    function BlobDownloader(socket, blobid, type, progress) {
        var _this = _super.call(this) || this;
        _this.socket = socket;
        _this.blobid = blobid;
        _this.type = type;
        _this.blobParts = [];
        _this.partSize = STARTPARTSIZE;
        _this.doneBytes = 0;
        _this.done = false;
        _this.download = function () {
            if (!_this.downloadPromise) {
                _this.downloadPromise = _this.downloadPartsUntilDone();
            }
            return _this.downloadPromise;
        };
        _this.downloadPartsUntilDone = function () {
            if (_this.done) {
                _this.progress.setTotal(_this.doneBytes);
                _this.progress.progress(_this.doneBytes);
                return _this.concatParts();
            }
            return _this.downloadPart().then(function () {
                return _this.downloadPartsUntilDone();
            });
        };
        _this.progress = progress || new Progress();
        return _this;
    }
    BlobDownloader.prototype.halfSize = function () {
        this.partSize = Math.max(this.partSize / 2, MINIMUMPARTSIZE);
    };
    ;
    BlobDownloader.prototype.doubleSize = function () {
        this.partSize = Math.min(this.partSize * 2, MAXIMUMPARTSIZE);
    };
    ;
    BlobDownloader.prototype.concatParts = function () {
        return Bluebird.resolve({
            blob: new Blob(this.blobParts, { type: this.type }),
            meta: this.meta
        });
    };
    BlobDownloader.prototype.downloadPart = function () {
        var _this = this;
        var uploadStarted = new Date().getTime();
        return this.socket.awaitConnection().then(function () {
            return _this.socket.emit("blob.getBlobPart", {
                blobid: _this.blobid,
                start: _this.doneBytes,
                size: _this.partSize
            });
        }).then(function (response) {
            var uploadTook = new Date().getTime() - uploadStarted;
            _this.blobParts.push(response.part);
            _this.doneBytes += response.part.byteLength;
            _this.progress.progress(_this.doneBytes);
            if (uploadTook > MAXIMUMTIME) {
                _this.halfSize();
            }
            else {
                _this.doubleSize();
            }
            _this.done = response.last;
            _this.meta = response.meta;
            _this.notify(_this.doneBytes, "progress");
        }).catch(function (e) {
            if (e instanceof ServerError) {
                var response = e.extra.response;
                if (h.hasErrorId(response, 71)) {
                    return Bluebird.reject(e);
                }
            }
            console.error(e);
            _this.halfSize();
            return Bluebird.delay(5000);
        });
    };
    ;
    return BlobDownloader;
}(Observer));
export default BlobDownloader;



//////////////////
// WEBPACK FOOTER
// ./js/services/blobDownloader.service.ts
// module id = null
// module chunks = 